import { Component, Vue } from 'vue-property-decorator';
import {Action} from 'vuex-class';

@Component
export default class CheckForUpdates extends Vue {
  @Action private addToastErrorMessage: any;
  private initialEtag: string | null = null;
  private updateExists: boolean = false;

  public mounted() {
    let hidden: string = '';
    let visibilityChange: any;
    const checkInterval: number = 120000;

    let updateCheck = setInterval(this.checkForUpdate.bind(this), checkInterval);

    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof (document as any).msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof (document as any).webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    const handleVisibilityChange = () => {
      // @ts-ignore
      if (document[hidden]) {
        clearInterval(updateCheck);
      } else {
        updateCheck = setInterval(this.checkForUpdate.bind(this), checkInterval);
        this.checkForUpdate();
      }
    };

    if (typeof document.addEventListener === 'undefined' || hidden === undefined) {
      // tslint:disable-next-line:no-console
      console.log('This page requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
    } else {
      // Handle page visibility change
      document.addEventListener(visibilityChange, handleVisibilityChange, false);
    }
  }

  private checkForUpdate() {
    let currentEtag: string | null = null;
    fetch('/', {method: 'HEAD'}).then((response) => {
      currentEtag = response.headers.get('etag');
      if (!currentEtag) {
        throw new Error(`Response header for HEAD request was empty.`);
      } else {
        if (this.initialEtag === null) {
          this.initialEtag = currentEtag;
        }
        if (currentEtag !== this.initialEtag) {
          this.updateExists = true;
        }
      }
    }).catch((e) => {
      // tslint:disable-next-line:no-console
      console.error(e);
    });
  }

  private refresh() {
    this.updateExists = false;
    window.location.reload();
  }
}
